import '../modules/web-components/sb-dialog-wrapper';
import '../modules/web-components/sb-pair-list-wrapper';
import * as emailPageOwner from './render/scripts/emailPageOwner-id7';
import * as twitterToX from './render/scripts/twitter-to-x';
import * as cookiePreferences from './render/scripts/cookie-preference';
import * as imageModals from './render/scripts/imagemodals';
import * as formsConditionalLogic from './render/scripts/forms-conditional-logic-render';

/** A place to pull together any scripts that could be useful _anywhere_ in SiteBuilder */

emailPageOwner.init();
twitterToX.convertIcons(document.body);
cookiePreferences.init();
imageModals.init();
formsConditionalLogic.init();
